import { makeStyles } from "@mui/styles";
import type { Theme } from "src/theme";

export const useErrorPageStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: "100%",

        padding: theme.spacing(3),
        paddingTop: 80,
        paddingBottom: 80,
    },
    image: {
        maxWidth: "100%",
        width: 560,
        maxHeight: 300,
        height: "auto",
    },
}));
